import type { StepConfigFor } from '../getStepConfig.types.ts';

export const GenerateConsentToReleaseHealthSummaryStepConfig = {
  title: ({ isHealthcareProvider }) =>
    isHealthcareProvider ? 'Consent to Release Health Summary' : 'Generate Your Consent to Release Health Summary',

  statuses: {
    NOT_STARTED: {
      label: 'Not Generated',
      cta: 'Generate Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with generating their letter of consent to release their health summary'
          : 'Please generate your letter of consent to release your health summary to us',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with generating their letter of consent to release their health summary'
          : 'Please generate your letter of consent to release your health summary to us',
    },

    PENDING: {
      label: 'Under Review',
      cta: 'Resubmit',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their letter of consent to release their health summary. Please review it and verify the status'
          : 'You have submitted your letter of consent to release your health summary to us. We are reviewing it and will update you shortly',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their letter of consent to release their health summary. We need to review it and update the status'
          : 'Your letter of consent to release your health summary to us is being reviewed. We will update you shortly',
    },

    COMPLETED: {
      label: 'Generated',
      cta: 'View',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully generated their letter of consent to release their health summary'
          : 'You have successfully generated your letter of consent to release your health summary to us',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully generated their letter of consent to release their health summary'
          : 'You have successfully generated your letter of consent to release your health summary to us',
    },

    ERROR: {
      label: 'Generation Failed',
      cta: 'Resubmit Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is required to re-generate their letter of consent to release their health summary'
          : 'There was an issue with your letter of consent to release your health summary. Please generate it again',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'There was an issue with the generated letter. The patient will need to resubmit it'
          : 'There was an issue with your letter of consent to release your health summary. Please generate it again',
    },
  },
} satisfies StepConfigFor<'GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY'>;
